import styled from "styled-components";

// Practically invisible and untappable, but on screen with a real size so
// iPhones treat the video as visible and allow it to load
export const HiddenPlayer = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;

  opacity: 0.001;
  pointer-events: none;
`;

export const DebugLog = styled.pre`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;

  margin: 0;
  padding: 4px;

  font-size: 11px;
  white-space: pre-wrap;
  color: #7fff7f;
  background-color: rgba(0, 0, 0, 0.85);

  pointer-events: none;
`;

export const ProgressBackground = styled.div`
  position: relative;
  z-index: -1;

  width: 100%;
  height: 20px;
  background-color: ${({ theme }) => theme.gray};
  border-radius: 2px;

  margin-top: 2%;
`;

// Width is set with an inline style because it changes every frame
export const Progress = styled.div`
  max-width: 100%;
  height: 20px;

  align-self: flex-start;

  background-color: ${({ theme }) => theme.green};

  border-radius: 2px;
`;

export const Separator = styled.div`
  position: absolute;
  top: 0;

  width: 1px;
  height: 100%;

  background-color: ${({ theme }) => theme.border100};
`;

export const TimeStamps = styled.div`
  position: relative;
  width: 100%;
  height: 1.2em;
`;

export const TimeStamp = styled.p`
  position: absolute;
  color: ${({ theme }) => theme.text};
  margin: 2px 0px;
`;

export const PlayButton = styled.button`
  display: flex;
  padding: 4px;
  margin-top: 4px;

  color: ${({ theme }) => theme.text};
  background: none;
  border: none;
  cursor: pointer;
`;
